<a class="zwi-tab-button" [routerLink]="[path]" routerLinkActive="zwi-tab-button--active">
  <mat-icon class="zwi-tab-icon">{{icon}}</mat-icon>
  <zwi-caption>{{ label }}</zwi-caption>
</a>
